import React from "react";
import Hero from "../components/Hero";
import HeaderNav from "../components/HeaderNav";
import Footer from "../components/Footer";
import { Analytics } from "@vercel/analytics/react";

const About = () => {
  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <Analytics />
        <HeaderNav />
        <Hero>
          <div className="flex flex-col px-32 py-5 gap-7 h-full justify-center laptop">
            <div className="gap-3 flex">
              <span className="  text-white font-bold text-5xl">About Us</span>
              <span className="text-yellow-400 font-bold text-5xl">
                And Our
              </span>
            </div>
            <span className="text-yellow-400 font-bold text-5xl">
              Predictions
            </span>
            <p className=" text-white font-normal text-xl w-2/3">
              Read carefully!
            </p>
          </div>
          <div className="flex flex-col px-5 md:px-10 py-5 gap-7 h-full phone justify-center z-50">
            <div className="flex gap-3 flex-wrap">
              <span className="text-white font-bold text-3xl sm:text-5xl md:w-screen">
                About Us
              </span>
              <span className=" text-yellow-400  font-bold text-3xl sm:text-5xl">
                And Our
              </span>
              <span className=" text-yellow-400 font-bold text-3xl sm:text-5xl ">
                Predictions
              </span>
            </div>
            <p className=" text-white font-normal sm:text-xl ">
              Read carefully!
            </p>
          </div>
        </Hero>
        <div className="flex w-screen items-center justify-center">
          <text className=" px-10 py-10 flex text-justify">
            {" "}
            At greenlucktips.com, We set a benchmark of making provision of safe
            and accurate football tips you can trust! Green Luck Tips
            predictions, tips & analysis are based on algorithms, detailed
            analysis, betting tips, forms and statistics. We have dedicated
            experts that are passionate in ensuring you make profits! We provide
            you with the most accurate and guaranteed football tips everyday of
            the week. We are relentless in our drive to assist many bettors make
            good use of the tips we provide to guarantee profits. Our strong
            presence in Nigeria, Kenya, Tanzania, South Africa, Uganda, Cyprus,
            Russia, United Kingdom, USA and other European countries makes us
            the number destination for all things related to soccer forecasts.
            Our tipsters at Green Luck Tips offer predictions for over 60
            leagues. We are thorough in our work and have the success of our
            users in mind. We promise to aid you in your bets! Wonder less we
            are considered the Home of Soccer Predictions!
          </text>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
